import { DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { WrittenCertificationForm } from "./written-certification-form";

@NgModule({
  declarations: [WrittenCertificationForm],
  exports: [WrittenCertificationForm],
  imports: [
    CommonComponentsModule,
    TranslateModule.forChild(),
    IonicPageModule.forChild(WrittenCertificationForm),
    FontAwesomeModule,
  ],
  providers: [DatePipe],
})
export class WrittenCertificationFormModule {}



// WEBPACK FOOTER //
// ./src/certification/forms/written-certification-form/written-certification-form.module.ts